/**
 * Central public inquiry address. The contact form intentionally opens a
 * prepared email until a reviewed form service or backend is connected.
 */
export const CONTACT_EMAIL = "inquiries@kratis.xyz";
export const CONTACT_EMAIL_IS_PLACEHOLDER = false;

export const SITE_NAME = "Kratis";
export const HOME_TITLE = "Kratis — Independent Wastewater Cost Review";
export const HOME_DESCRIPTION =
  "Kratis independently checks industrial wastewater cost increases, sampling evidence, and plant events—then gives management a clear next move and a way to verify the result.";
